//JS code if they want to manually input a date.

// function countdownTimer(targetDatee, elementId) {
//   const targetTime = new Date(targetDatee).getTime();

//   function updateTimer() {
//     const now = new Date().getTime();
//     const timeLeft = targetTime - now;

//     if (timeLeft >= 0) {
//       const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
//       const hours = Math.floor(
//         (timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
//       );
//       const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
//       const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

//       document.getElementById("day").innerHTML = `${days}`;
//       document.getElementById("hour").innerHTML = ` ${hours}`;
//       document.getElementById("minute").innerHTML = `${minutes}`;
//       // alert('Countdown good');
//     } else {
//       document.getElementById(elementId).innerHTML = "<p>Countdown Expired</p>";
//       //   document.getElementById("promopill").classList.add("hidePill");
//     }
//   }

//   updateTimer();
//   const interval = setInterval(updateTimer, 1000);
//   // alert('Countdown Expddddired');
// }

function countdownTimer24(hour, minute, seconds) {
  // const now = new Date().getTime();
  // const timeLeft = 24 - now;

  function updateTimer() {
    var d = new Date();
    var hours = 23 - d.getHours();
    var min = 60 - d.getMinutes();
    if ((min + "").length == 1) {
      min = "0" + min;
    }
    var sec = 60 - d.getSeconds();
    if ((sec + "").length == 1) {
      sec = "0" + sec;
    }

    // var elems = document.getElementsByClassName("banner-gallery__title");
    // for (var i = 0, l = elems.length; i < l; i++) {
    //   document.getElementsByClassName("hour timeDisplay")[i].innerHTML = hours;
    //   document.getElementsByClassName("minute timeDisplay")[i].innerHTML = min;
    //   document.getElementsByClassName("seconds timeDisplay")[i].innerHTML = sec;
    // }

    // document.getElementsByClassName("hour timeDisplay")[0].innerHTML = hours;
    // document.getElementsByClassName("minute timeDisplay")[0].innerHTML = min;
    // document.getElementsByClassName("seconds timeDisplay")[0].innerHTML = sec;

    // document.getElementsByClassName("hour timeDisplay")[1].innerHTML = hours;
    // document.getElementsByClassName("minute timeDisplay")[1].innerHTML = min;
    // document.getElementsByClassName("seconds timeDisplay")[1].innerHTML = sec;

    // document.querySelector("div.timeblock > p.hour").innerHTML = hours;
    // document.querySelector("div.timeblock > p.minute").innerHTML = min;
    // document.querySelector("div.timeblock > p.seconds").innerHTML = sec;
    // console.log(hours, min, sec);

    // document.getElementById(hour).innerHTML = hours;
    // document.getElementById(minute).innerHTML = min;
    // document.getElementById(seconds).innerHTML = sec;
    // return hours;

    document
      .querySelectorAll("p.hour")
      .forEach((node) => (node.innerHTML = hours));
    document
      .querySelectorAll("p.minute")
      .forEach((node) => (node.innerHTML = min));
    document
      .querySelectorAll("p.seconds")
      .forEach((node) => (node.innerHTML = sec));
  }
  setInterval(updateTimer, 1000);
}
